;

(function (GC) {
  window.GC = GC;

  var GCLoader = function GCLoader() {
    return {
      //Show a wait screen. This is called by data-confirm callback and when there is only a wait message, without confirm.
      show_wait_screen: function show_wait_screen(args) {
        message = args.message || args.element.data('wait');
        var loaderHTML = '<span class="center-block p-h-sm text-center"> ' + message + ' </span><div class="sk-spinner sk-spinner-three-bounce p-h-sm text-center loader" id="loader" ><div class="sk-bounce1"></div><div class="sk-bounce2"></div><div class="sk-bounce3"></div></div>';
        $('#loader').remove();
        var modalId = args.modalId != null && args.modalId != undefined && args.modalId != '' ? args.modalId : 'myModal';
        $('#' + modalId).modal('show').find('.modal-content').css('height', 'auto').prepend(loaderHTML);

        if ($('#loader').is(':visible')) {
          $('#loader').parents('.modal-dialog').addClass('modal-sm loader-v-middle');
          $('#loader').parents('.modal-dialog').find('.close').hide();
          $('#loader').next('span').remove();
          $('#' + modalId).find('.modal-body, .modal-footer').empty().hide();
        }

        if ($('form')[0] != undefined && $('form')[0].length > 0 && !$('form')[0].checkValidity()) {
          GC.loader.hide_wait_screen();
        }

        $('.dd.open .dropdown-toggle').dropdown('toggle');
      },
      hide_wait_screen: function hide_wait_screen() {
        $('#loader').remove();
        $('#loader').parents('.modal-dialog').removeClass('modal-sm loader-v-middle');
        $('#myModal').modal('hide');
      }
    };
  };

  GC.queue = GC.queue || [];
  GC.queue.push({
    method: function method(mount, GCmodule) {
      this._loadModule(mount, GCmodule);
    },
    args: ['loader', new GCLoader()]
  });
})(window.GC || {});